export const SET_DARK_MODE = 'SET_DARK_MODE'
export const SET_PAGES_ITEMS = 'SET_PAGES_ITEMS'
